<template>
  <main class="p-error l-page">
    <section class="p-error__wrap">
      <h2 class="c-regist__title">{{ title }}</h2>
      <p class="c-regist__comment message" v-html="message"></p>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import useMaintenanceStatus from '@/Hooks/useMaintenanceStatus'

export default defineComponent({
  name: 'MaintenancePage',
  setup() {
    const { fetchMaintenanceStatus, title, message } = useMaintenanceStatus()
    fetchMaintenanceStatus()

    return {
      title,
      message,
    }
  },
  components: {},
})
</script>

<style scoped lang="scss"></style>
